import { isFocusable } from './is-focusable.js';

/**
 * @internal
 *
 * If you need access to the first focusable descendant of a container, you can use
 * `getFirstFocusableChild`. The function uses the
 * https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker to
 * iterate over the children of the container and returns either a `Node` if a
 * focusable element is found, or `null`.
 */
export function getFirstFocusableChild(
  container: HTMLElement | Node,
): Node | null {
  const treeWalker = document.createTreeWalker(container);

  // Iterate over all the nodes inside the container and return the current node if it is focusable.
  while (treeWalker.nextNode()) {
    if (isFocusable(treeWalker.currentNode)) {
      return treeWalker.currentNode;
    }
  }

  return null;
}
